import { render, staticRenderFns } from "./TariffsRate.vue?vue&type=template&id=6f0060fe&scoped=true"
import script from "./TariffsRate.vue?vue&type=script&lang=js"
export * from "./TariffsRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0060fe",
  null
  
)

export default component.exports